import { defineMessages } from "react-intl";

export const messages = defineMessages({
  beneficiary: {
    id: "bankTransfer.beneficiary",
    defaultMessage: "Beneficiary",
  },
  statementDescriptor: {
    id: "bankTransfer.statementDescriptor",
    defaultMessage: "RING TWICE",
  },
  iban: {
    id: "bankTransfer.iban",
    defaultMessage: "IBAN",
  },
  amount: {
    id: "bankTransfer.amount",
    defaultMessage: "Amount",
  },
  reference: {
    id: "bankTransfer.reference",
    defaultMessage: "Reference",
  },
  pay: {
    id: "bankTransfer.pay",
    defaultMessage: "Pay {amount}",
  },
  amountToPay: {
    id: "bankTransfer.amountToPay",
    defaultMessage: "{ amountToPay }",
  },
  ibanValue: {
    id: "bankTransfer.ibanValue",
    defaultMessage: "BE05 3631 2321 2975",
  },
  bankCommunication: {
    id: "bankTransfer.bankCommunication",
    defaultMessage: "RingTwice-{ userId }",
  },
});
